import * as actionTypes from '../actions/actionTypes';

import updateObject from '../../util/updateObject';

const initialState = {
    settlements: [], 
    loading: false, 
    error: null, 
    selectedSettlement: null
};

const setSettlements = (state, settlements) => {
    return updateObject(state, { loading: false, error: null, settlements });
}

const settlementGetSettlementsFromServerStart = (state, action) => {
    return updateObject(state, { loading: true, error: null, settlements: [] });
}

const settlementGetSettlementsFromServerSuccess = (state, action) => {
    return setSettlements(state, action.settlements);
}

const settlementGetSettlementsFromServerFail = (state, action) => {
    return updateObject(state, { loading: false, error: action.error });
}

const settlementGetSettlementsFromCache = (state, action) => {
    if(state.loading && action.settlements.length > 0) {
        return setSettlements(state, action.settlements);
    }
    else {
        return state;
    }
}

const settlementGetStart = (state, action) => {
    return updateObject(state, { loading: true, error: null, selectedSettlement: null });
};

const settlementGetSuccess = (state, action) => {
    return updateObject(state, { loading: false, error: null, selectedSettlement: action.settlement });
};

const settlementGetFail = (state, action) => {
    return updateObject(state, { loading: false, error: action.error });
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SETTLEMENT_GET_SETTLEMENTS_FROM_CACHE: return settlementGetSettlementsFromCache(state, action);
        case actionTypes.SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_START: return settlementGetSettlementsFromServerStart(state, action);
        case actionTypes.SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_SUCCESS: return settlementGetSettlementsFromServerSuccess(state, action);
        case actionTypes.SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_FAIL: return settlementGetSettlementsFromServerFail(state, action);

        case actionTypes.SETTLEMENT_GET_START: return settlementGetStart(state, action);
        case actionTypes.SETTLEMENT_GET_SUCCESS: return settlementGetSuccess(state, action);
        case actionTypes.SETTLEMENT_GET_FAIL: return settlementGetFail(state, action);

        default: return state;
    }
}

export default reducer;